import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VCol,
    { class: "mb-2 col-md-" + _vm.colSize },
    [
      _c(
        VMenu,
        {
          attrs: {
            "close-on-content-click": false,
            "nudge-right": 40,
            transition: "scale-transition",
            "offset-y": "",
            "min-width": "290px",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    VTextField,
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            "append-icon": "event",
                            readonly: "",
                            dense: "",
                            outlined: "",
                            "hide-details": "auto",
                            label: _vm.label,
                          },
                          on: { "click:append": on.click },
                          model: {
                            value: _vm.formattedDate,
                            callback: function ($$v) {
                              _vm.formattedDate = $$v
                            },
                            expression: "formattedDate",
                          },
                        },
                        "v-text-field",
                        attrs,
                        false
                      ),
                      on
                    )
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c(
            VCard,
            { staticClass: "date-time-picker-card" },
            [
              _c(VDatePicker, {
                attrs: { range: "", min: _vm.fechaMin, max: _vm.fechaMax },
                on: { input: _vm.handleInput },
                model: {
                  value: _vm.internalValue,
                  callback: function ($$v) {
                    _vm.internalValue = $$v
                  },
                  expression: "internalValue",
                },
              }),
              _vm.includeTime ? _c(VDivider) : _vm._e(),
              _vm.includeTime
                ? _c("div", { staticClass: "pa-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-center justify-space-between mb-2",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center" },
                          [
                            _c(
                              VIcon,
                              { staticClass: "mr-2", attrs: { small: "" } },
                              [_vm._v("mdi-clock-outline")]
                            ),
                            _c("span", { staticClass: "text-subtitle-2" }, [
                              _vm._v("Inicio:"),
                            ]),
                          ],
                          1
                        ),
                        _c(VTextField, {
                          staticStyle: { "max-width": "100px" },
                          attrs: {
                            type: "time",
                            dense: "",
                            outlined: "",
                            "hide-details": "",
                          },
                          on: { change: _vm.onTimeChange },
                          model: {
                            value: _vm.startTime,
                            callback: function ($$v) {
                              _vm.startTime = $$v
                            },
                            expression: "startTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-center justify-space-between",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center" },
                          [
                            _c(
                              VIcon,
                              { staticClass: "mr-2", attrs: { small: "" } },
                              [_vm._v("mdi-clock-outline")]
                            ),
                            _c("span", { staticClass: "text-subtitle-2" }, [
                              _vm._v("Fin:"),
                            ]),
                          ],
                          1
                        ),
                        _c(VTextField, {
                          staticStyle: { "max-width": "100px" },
                          attrs: {
                            type: "time",
                            dense: "",
                            outlined: "",
                            error: _vm.hasTimeError,
                          },
                          on: { change: _vm.onTimeChange },
                          model: {
                            value: _vm.endTime,
                            callback: function ($$v) {
                              _vm.endTime = $$v
                            },
                            expression: "endTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.hasTimeError
                      ? _c(
                          "div",
                          { staticClass: "text-caption error--text mt-1" },
                          [
                            _c(
                              VIcon,
                              { staticClass: "mr-1", attrs: { small: "" } },
                              [_vm._v("mdi-alert-circle")]
                            ),
                            _vm._v(" Rango de tiempo inválido "),
                          ],
                          1
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _c(VDivider),
              _c(
                "div",
                { staticClass: "d-flex justify-end pa-3" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mr-2",
                      attrs: { text: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.menu = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("btns.cancel")))]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { text: "", color: "primary" },
                      on: { click: _vm.confirmSelection },
                    },
                    [_vm._v(_vm._s(_vm.$t("btns.ok")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }